export const modalContainer = ({ modalContainerStyles }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 3000,
  background: "rgba(0,0,0,0.7)",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "100px 30px",
  overflow: "auto",
  ...modalContainerStyles,
});

export const centeredBox =
  ({ background, boxShadow, modalBottom }) =>
  ({ isDesktop, isTablet, isMobile }) => ({
    margin: isMobile ? 0 : "auto",
    position: "relative",
    zIndex: 2000,
    background: `${background}`,
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    borderRadius: "10px",
    boxShadow: `${boxShadow}`,
    maxWidth: isDesktop ? "800px" : isTablet ? "600px" : "400px",
    width: "100%",
    bottom: `${modalBottom}`,
  });
